"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "useResizeColumns", {
  enumerable: true,
  get: function () {
    return _useResizeColumns.useResizeColumns;
  }
});

var _useResizeColumns = require("./useResizeColumns");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVGFibGUvdXNlUmVzaXplQ29sdW1ucy9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyB1c2VSZXNpemVDb2x1bW5zIH0gZnJvbSAnLi91c2VSZXNpemVDb2x1bW5zJ1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQSJ9